import React from 'react';

function Checkbox({ obj, id, value = '', name = '', checked, onChange }) {
  return (
    <>
      <div className="checkbox-container">
        <input className="box" type="checkbox" id={ id } name={ name } value={ value } checked={ checked } onChange={ onChange } />
        <label className="checkbox-label cursor-pointer" htmlFor={ id }><span dangerouslySetInnerHTML={ { __html: obj.name || obj.title?.rendered } } /></label>
      </div>
    </>
  );
}

export default Checkbox;
